<template>
  <div class="import-box import_new_wrap" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 标题 -->
    <div class="import-title">
      <div class="back" @click="$router.back()">返回</div>
      <!-- <div class="import-back"><i class="el-icon-arrow-left" style="padding-right: 10px"></i> 返回</div> -->
      <span>简历信息导入</span>
    </div>
   
    <div class="button-area mt0 ">
      <div>
        <el-button size="mini" type="importNew" @click="dialogVisible = true">批量导入</el-button>
        <el-button size="mini" type="borderGreen" @click="getData(true)">刷新结果</el-button>
        <span style="color:#999;margin-left:10px">请及时刷新查看最终结果</span>
      </div>
      <div class="mr16">
        <el-button size="mini" type="deleteNew" @click="delFile(1)">批量删除</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="back-color-fff content-main-box"  >
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange"
        border
        v-loading="tableWrapLoading"
        style="width: 100%"
        height="60vh"
        stripe 
        :header-cell-style="{background:'#f4f4f5'}"
      >
        <el-table-column type="selection" width="60" header-align="center" align="center" :selectable="selected"></el-table-column>
        
        
        <el-table-column
          prop="fileName"
          label="文件名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="240"
        >
          <template slot-scope="scope">{{ scope.row.fileName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="importState"
          label="状态"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="85"
        >
          <template slot-scope="scope">
            <span :class="getStateClass(scope.row.importState)">{{scope.row.importState | importStateNew}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="importMessage"
          label="导入结果"
          header-align="center"
          align="left"
          show-overflow-tooltip
          min-width="250"
        >
          <template slot-scope="scope">{{ scope.row.importMessage || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="导入时间"
          header-align="center"
          align="left"
          show-overflow-tooltip
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.createTime | getTime}}</template>
        </el-table-column>
        <el-table-column prop="bank" width="230px" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a :class="scope.row.importState == 1 ? 'fontC-bbb cursor-sty' : 'txt-color'" @click="downloadFile(scope.row.filePath, 1,scope.row.importState)">下载文件 </a>
            <a class="txt-color" @click="downloadFile(scope.row.errorFilePath, 2)" v-if="scope.row.importState == -1">
              ｜下载异常数据</a
            >
            <a class="txt-color" @click="delFile(2, scope.row.guid)" v-if="scope.row.importState !== 1"> ｜删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- 弹窗 -->
    <el-dialog title="导入数据" :visible.sync="dialogVisible" width="800px">
      <div class="import-dialog-box">
        <div class="import-dialog-title">
          <img src="../../assets/icon/import_warning.png" alt="" /> 若导入数据已存在，那么信息将会覆盖，请谨慎操作。
        </div>
       
        <div class="import-dialog-item">
          <div class="import-step-title">1、请下载最新的模板，并按照模板格式准备需要导入的数据</div>
          <div class="t-left">
            <el-button
              size="mini"
              icon="el-icon-my-down"
              style="margin-top: 8px; margin-bottom: 0"
              type="importDown"
              @click="downloadFile(templateUrl)"
              >下载模板</el-button
            >
          </div>
        </div>
        <div class="import-dialog-item">
          <div class="import-step-title">2、选择准备好的文件导入</div>
          <div class="import-step-tip">当前支持excel格式文件，单个文件不得大于5M</div>
          <el-upload
            class="upload-demo t-left"
            action="#"
            :file-list="fileList"
            :before-upload="beforeUpload"
            multiple
            accept=".xlsx,.xsl,.xls,.xlsm"
            :auto-upload="false"
            :on-change="changeFile"
          >
            <el-button
              size="mini"
              icon="el-icon-my-import"
              style="margin-top: 8px; margin-bottom: 0"
              type="importNew"
              v-loading.fullscreen.lock="fullscreenLoading"
              >导入文件</el-button>
          </el-upload>
          
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="dialogVisible=false">取消</el-button>
        <el-button type="info" @click="importSure">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import importCommon from '@/uilt/importCommon';
export default {
  data() {
    return {
      exportUrl: `/${serverConfig.msCommonImportDataService}/import-data/import-common`,
      
      // importType:'',//导入类型
      tableData: [],
      tableWrapLoading: false,
      fullscreenLoading: false,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        importType: '0034', //导入类型
      },
      dialogVisible: false,
      templateUrl: '/简历信息导入模板.xlsx', //模板地址
      multipleSelection: [],
      tenantGuid: '',
      tenantList: [],
      fileList: [],
    };
  },
  created() {
    this.getData(true);
    // this.getTenantOperationRelList();
  },
  methods: {
    //禁用导入中状态选项
    selected(row) {
      return importCommon.getDelSelected(row.importState);
    },
    //获取公司下拉
    getTenantOperationRelList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      let query = JSON.parse(JSON.stringify(self.page));
      // query.accountMonth = query.accountMonth.replace('-', '');
      let userInfo = JSON.parse(localStorage.userInfo);
      query.staffGuid=userInfo.staffGuid
      self.tableWrapLoading = true;
      // /import-data-new/medicine-policy
      // /${serverConfig.msCommonImportDataService}/import-data/list
      self.api
        .postJson(`/${serverConfig.msCommonImportDataService}/import-data/list`, query)
        .then((res) => {
          self.tableWrapLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records || [];
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          self.tableWrapLoading = false;
        });
    },
    empty() {
      let self = this;
      self.page.pageIndex = 1;
      self.getData(true);
    },
    //获取状态样式
    getStateClass(state) {
      return importCommon.getImportStateClass(state);
    },
    //下载文件/模板
    downloadFile(url, type,state) {
      if(type == 1 && state == 1){
        this.$message.error(messageConfig.IMPORT_HANDLE);
        return
      }
      if(!url){
        this.$message.error(messageConfig.IMPORT_FILE_BROKEN);
        return
      }
      // type为1下载文件 2为异常数据下载文件 不为1下载模板
      window.open(url);
    },
    //导入确定
    importSure() {
      this.fileList = [];
      this.tenantGuid = null;
      this.getData(1);
      this.dialogVisible = false;
    },
    //选择表格数据
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      if (val && val.length > 0) {
        val.forEach((i) => {
          self.multipleSelection.push(i.guid);
        });
      }
    },
    //删除文件
    delFile(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error(messageConfig.DELETE_SELECT);
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm(messageConfig.DELETE_AFTER, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.tableWrapLoading = true;
          self.api
            .postJson(`/${serverConfig.msCommonImportDataService}/import-data/delete`, self.multipleSelection)
            .then((res) => {
              self.tableWrapLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success(messageConfig.DELETE_SUCCESS);
                self.getData(1);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: messageConfig.CANCEL_TIP,
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    // 导入
   
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx' && arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    // 上传文件
    changeFile(file, fileList) {
      let self = this;
      if (fileList.length > 1 && file.status !== "fail") {
        fileList.splice(0, 1);
      }
      let isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        self.$message.error('上传文件大小不能超过 5MB');
        file = null;
        fileList = [];
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
      } else {
        self.fullscreenLoading = true;
        let userInfo = JSON.parse(localStorage.userInfo);
        // extendFields 其余字段json
        let extendFields = JSON.stringify({serviceTenantGuid:localStorage.guid});
        let formData = new FormData();
        formData.append('file', file.raw); //传文件
        formData.append('importType', this.page.importType);
        formData.append('extendFields', extendFields);
        formData.append('tenantGuid', localStorage.guid);
        formData.append('staffGuid', userInfo.staffGuid);
        self.api
          .postFile(
            self.exportUrl,
            formData,
          )
          .then(function (res) {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message({
                type: 'success',
                message: messageConfig.UPLOAD_SUCCESS,
              });
              self.getData(1);
            } else {
              self.$message({
                type: 'error',
                message: res.data.msg,
              });
              return false;
            }
          });
      }
    },
    
  },
};
</script>
<style lang="less" scoped>
.import-title {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
.import-title .back {
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }
</style>